import Addon from '../../../../shared/classes/addon';
import ChannelUtils from '../../../../shared/utils/channels';
import Content from '../../../../shared/types/enums/content';
import Price from './descriptionAddonPrice';
import Text from '../../atoms/text/descriptionAddonSubscribedText';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { useMemo } from 'react';

interface Props {
  asset: Addon;
}

export default function DescriptionAddonSubscription({ asset }: Props) {
  const { hasAddon, subscriptionText } = useMemo(() => {
    const hasAddon = asset?.type === Content.ADDON ? asset.checkAddon() : false;
    const totalChannels =
      (asset?.plan && ChannelUtils.getPlanChannels(asset.plan)?.length) || 0;
    const subscriptionText = hasAddon ? (
      TranslationManager.get('COMPONENTS.RAILS.DESCRIPTION.ALREADY_SUBSCRIBED')
    ) : asset?.isFree ? (
      asset?.offerClaim ? (
        <>{asset.offerClaim}</>
      ) : (
        <>
          {' '}
          {TranslationManager.get('PAGES.ADDON.FREE_CHANNELS_1')}
          <br></br>
          {TranslationManager.get('PAGES.ADDON.FREE_CHANNELS_2') +
            (totalChannels && totalChannels > 1 ? ` ${totalChannels} ` : ' ') +
            TranslationManager.get('PAGES.ADDON.FREE_CHANNELS_3')}
        </>
      )
    ) : null;
    return { hasAddon, subscriptionText };
  }, [asset]);

  return hasAddon || asset?.isFree ? (
    subscriptionText ? (
      <Text>{subscriptionText}</Text>
    ) : null
  ) : (
    <Price asset={asset} />
  );
}
